import { useStaticQuery, graphql } from "gatsby"

export default function useHeroImages() {
  const query = useStaticQuery(graphql`
    query {
      lg: file(
        relativePath: {
          eq: "1_SOLUTIONS/Mapping CMS - Internal Pages/Analytics Dashboard/Hero Images/hero_desktop.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 1440) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      md: file(
        relativePath: {
          eq: "1_SOLUTIONS/Mapping CMS - Internal Pages/Analytics Dashboard/Hero Images/hero_tablet.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      sm: file(
        relativePath: {
          eq: "1_SOLUTIONS/Mapping CMS - Internal Pages/Analytics Dashboard/Hero Images/hero_mobile.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  const images = Object.keys(query).reduce((acc, current) => {
    acc[current] = query[current].childImageSharp.fluid
    return acc
  }, {})

  return images
}
